<template>
  <div
    id="report"
    class="page"
  >
    <template v-if="!loading">
      <Banner :banner="page.banner" />
      <section
        id="content_section"
        class="container bg-white text-left"
      >
        <div class="row">
          <div
            class="pt-4 pb-5"
            :class="page.sidemenu? 'col-lg-9 order-lg-2': 'col-lg-12'"
          >
            <Breadcrumb :items="[{ name: page.title, url: path }]" />
            <div class="content py-4">
              <template v-if="!loading && data">
                <div
                  v-if="data.annual"
                  id="annual_reports"
                >
                  <h1 class="articleTitle text-osc">
                    {{ $t('component.annual_reports') }}
                  </h1>
                  <div
                    v-lazy-container="{ selector: 'img.thumb' }"
                    class="articleBodyFullWidth"
                  >
                    <div class="row text-center">
                      <div
                        v-for="(item, index) in data.annual"
                        :id="`annual_${index}`"
                        :key="`annual_${index}`"
                        class="col-xl-3 col-lg-4 col-md-3 col-sm-4 col-6 mb-4"
                      >
                        <a
                          class="d-block"
                          :href="getAssetLink(item.file)"
                          target="_blank"
                        >
                          <img
                            class="thumb"
                            :data-src="getAssetLink(item.image)"
                            :data-error="$config.lazyload.report"
                          >
                        </a>
                        <a
                          class="d-block mt-3"
                          :href="getAssetLink(item.file)"
                          target="_blank"
                        >
                          <img
                            class="arrow"
                            src="/images/arrow_red.gif"
                          >
                          {{ item.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="data.fundraising || data.audit"
                  id="financial_reports"
                  class="mt-5"
                >
                  <h1 class="text-osc">
                    {{ $t('component.financial_reports') }}
                  </h1>
                  <div v-lazy-container="{ selector: 'img.thumb' }">
                    <div class="row">
                      <div
                        v-if="data.fundraising"
                        class="col-sm-6 mt-4"
                      >
                        <div class="blackTitle">
                          {{ $t('component.fundraising_reports') }}:
                        </div>
                        <a
                          v-for="(item, index) in data.fundraising"
                          :id="`fundraising_${index}`"
                          :key="`fundraising_${index}`"
                          class="d-block mt-3"
                          :href="getAssetLink(item.file)"
                          target="_blank"
                        >
                          <img
                            class="arrow"
                            src="/images/arrow_red.gif"
                          >
                          {{ item.name }}
                          <template v-if="item.sub_name">
                            <br>
                            {{ item.sub_name }}
                          </template>
                        </a>
                      </div>
                      <div
                        v-if="data.audit"
                        class="col-sm-6 mt-4"
                      >
                        <div class="blackTitle">
                          {{ $t('component.audit_reports') }}:
                        </div>
                        <a
                          v-for="(item, index) in data.audit"
                          :id="`audit_${index}`"
                          :key="`audit_${index}`"
                          class="d-block mt-3"
                          :href="getAssetLink(item.file)"
                          target="_blank"
                        >
                          <img
                            class="arrow"
                            src="/images/arrow_red.gif"
                          >
                          {{ item.name }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <SideMenu
            v-if="page.sidemenu"
            class="col-lg-3 py-4 order-lg-1"
            :data="page.sidemenu"
          />
        </div>
      </section>
      <!-- <section class="container bg-white py-4 clearfix d-none d-md-block" id="donate_btn_section">
        <DonateBtn class="animated fadeInRight" v-view.once/>
      </section>-->
    </template>
  </div>
</template>
<script>
import Banner from "@/components/Banner.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import SideMenu from "@/components/SideMenu.vue";
import * as _ from "lodash";

export default {
  name: "Report",
  components: { Banner, SideMenu, Breadcrumb },
  data() {
    let to = this.$router.history.current;
    return {
      path: to.path,
      loading: true,
      page: {
        sidemenu: {},
        banner: null,
        title: this.$t("page.report")
      },
      data: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.$http
        .get(this.path)
        .then(response => {
          this.data = response.data.data;
        })
        .finally(() => {
          this.page.banner = this.data.image;
          this.page.title =
            this.getDataValue("name", this.data) || this.page.title;

          let past_bene =
            this.data &&
            this.getDataValue("left_menu_header", this.data) ==
              this.$t("component.past_beneficiaries");
          let current_bene =
            this.data &&
            this.getDataValue("left_menu_header", this.data) ==
              this.$t("component.beneficiaries");
          if (past_bene || current_bene) {
            this.page.sidemenu["past_bene"] = past_bene;
            this.page.sidemenu["current_bene"] = current_bene;
          }
          if (_.isEmpty(this.page.sidemenu)) this.page.sidemenu = null; // Hide SideMenu if there're no items

          this.$route.meta.title = this.page.title;
          this.$route.meta.desc = this.data.desc;
          this.$meta().refresh(); // Important!

          if (this.data && this.data.report) {
            this.data = this.data.report;
            this.loading = false;
          }
        });
    }
  }
};
</script>